<template>
  <li class="featured-module panel panel-default" :aria-labelledby="headingId">
    <div class="panel-body">
      <h3 :id="headingId" class="featured-title">
        <span v-if="programmeModule.number" class="module-number">{{ programmeModule.number }}</span>
        {{ programmeModule.name }}
      </h3>

      <k-progress
        customText="Completed"
        :percentage="programmeModule.percentage"
        :precision="1"
        shape="bar"
        size="small"
        ariaLabel="Module completion percentage"
      ></k-progress>

      <div class="featured-meta">
        <span class="meta-item">
          Released: {{ formatDate(programmeModule.release_date) }}
        </span>
        <span class="meta-item" v-if="programmeModule.expected_completion_date">
          Due by: {{ formatDate(programmeModule.expected_completion_date) }}
        </span>
      </div>

      <router-link :to="modulePageTo" class="btn btn-primary featured-action">
        <i class="fa-regular fa-play" aria-hidden="true"></i> Continue Learning
      </router-link>
    </div>
  </li>
</template>

<style scoped>
.featured-module {
  list-style: none;
  margin-bottom: 10px;
  border: 1px solid var(--kate-panel-gradient-border);
  border-radius: 12px;
  background: var(--kate-panel-gradient);
}

.featured-badge {
  display: inline-block;
  margin-bottom: 10px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--kate-type-dark);
  background-color: var(--kate-primary);
}

.featured-title {
  margin: 0 0 10px;
}

.featured-meta {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  color: var(--kate-type-light);
  font-size: 0.9rem;
}

.featured-action {
  margin-top: 14px;
  float: right;
}
</style>

<script>
import TimeMixin from '../../../mixins/time-mixins';
import KProgress from '../../../components/k-progress.vue';

export default {
  components: {
    KProgress,
  },

  mixins: [TimeMixin],

  props: {
    programmeModule: {
      type: Object,
      required: true,
    },
  },

  beforeMount() {
    this.uuid = this.$.uid;
  },

  data() {
    return {
      uuid: null,
    };
  },

  computed: {
    headingId() {
      return `featured-module-${this.uuid}-heading`;
    },

    modulePageTo() {
      return {
        name: 'module_landing',
        params: { moduleId: this.programmeModule.id },
      };
    },
  },

  methods: {
    formatDate(value) {
      if (!value) {
        return '-';
      }
      return this.parseTimestamp(value, undefined, 'MMM d, yyyy');
    },
  },
};
</script>
